import { render, staticRenderFns } from "./ItemRL.vue?vue&type=template&id=6dddbb00"
import script from "./ItemRL.vue?vue&type=script&lang=js"
export * from "./ItemRL.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports